import { render, staticRenderFns } from "./Belposhta.vue?vue&type=template&id=e4a431b8&scoped=true"
import script from "./Belposhta.vue?vue&type=script&lang=js"
export * from "./Belposhta.vue?vue&type=script&lang=js"
import style0 from "./Belposhta.vue?vue&type=style&index=0&id=e4a431b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a431b8",
  null
  
)

export default component.exports